/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { StationGnvSimplePagedList } from '../../models/station-gnv-simple-paged-list';
import { StationGnvSimpleSearch } from '../../models/station-gnv-simple-search';

export interface SearchStationsSimplify$Json$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The search text to filter API
 */
  search?: string;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the station's name
 *   * CODE : the station's code
 *   * SERVICE : the station's service
 */
  sortFieldName?: 'NAME' | 'CODE' | 'SERVICE';

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for simplified station search
     */
    body?: StationGnvSimpleSearch
}

export function searchStationsSimplify$Json(http: HttpClient, rootUrl: string, params?: SearchStationsSimplify$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StationGnvSimplePagedList>> {
  const rb = new RequestBuilder(rootUrl, searchStationsSimplify$Json.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StationGnvSimplePagedList>;
    })
  );
}

searchStationsSimplify$Json.PATH = '/custom/stations/simplify/search';
